// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px; /* Ajout de l'espace entre les cartes */
}

.social-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px; /* Ajustement de la marge pour espacer les cartes */
}

.social-card-name {
  opacity: 0;
  transition: opacity 0.5s ease, transform 0.4s ease; 
  text-align: center;
}

.social-card.inline {
  display: inline-block;
}

.social-card-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #333;
  padding: 20px;
  border-radius: 5px;
  overflow: hidden;
  font-size: 17px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  letter-spacing: 0.5ch;
}

.social-card-content:hover .social-card-name {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.5s ease, transform 0.4s ease;
}

.social-card-content img {
  width: calc(1em + 35px);
  height: calc(1em + 35px);
  margin-bottom: 5px;
}

.social-card-name {
  margin: 0;
  transform: translateY(100%);
}

@media only screen and (max-width: 1500px) {
  .social-card {
    margin-top: 0px;
    margin-bottom: 5px;
  }
  
  .social-card-content {
    padding: 5px;
    border-radius: 0px;
    font-size: 15px;
    letter-spacing: 0.4ch;
  }
  
  .social-card-content img {
    margin-bottom: 10px;
    padding: 10px;
  }
}

@media only screen and (max-width: 750px) {
  .social-card-container {
    margin-bottom: 0px;

  }
  .social-card {
    margin-top: 15px;
  }
  
  .social-card-content {
    padding: 5px;
    border-radius: 0px;
    font-size: 12px;
    letter-spacing: 0.4ch;
    padding: 3px;
    margin-bottom: 0px;
  }
  
  .social-card-content img {
    width: calc(1em + 20px);
    height: calc(1em + 20px);
    margin-bottom: 10px;
    padding: 10px;
  }
  
  .social-card-name {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/Cards/cards-css/social-card.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS,EAAE,uCAAuC;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAE,mDAAmD;AACnE;;AAEA;EACE,UAAU;EACV,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;;EAEpB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".social-card-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px; /* Ajout de l'espace entre les cartes */\n}\n\n.social-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 20px; /* Ajustement de la marge pour espacer les cartes */\n}\n\n.social-card-name {\n  opacity: 0;\n  transition: opacity 0.5s ease, transform 0.4s ease; \n  text-align: center;\n}\n\n.social-card.inline {\n  display: inline-block;\n}\n\n.social-card-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-decoration: none;\n  color: #333;\n  padding: 20px;\n  border-radius: 5px;\n  overflow: hidden;\n  font-size: 17px;\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n  letter-spacing: 0.5ch;\n}\n\n.social-card-content:hover .social-card-name {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 0.5s ease, transform 0.4s ease;\n}\n\n.social-card-content img {\n  width: calc(1em + 35px);\n  height: calc(1em + 35px);\n  margin-bottom: 5px;\n}\n\n.social-card-name {\n  margin: 0;\n  transform: translateY(100%);\n}\n\n@media only screen and (max-width: 1500px) {\n  .social-card {\n    margin-top: 0px;\n    margin-bottom: 5px;\n  }\n  \n  .social-card-content {\n    padding: 5px;\n    border-radius: 0px;\n    font-size: 15px;\n    letter-spacing: 0.4ch;\n  }\n  \n  .social-card-content img {\n    margin-bottom: 10px;\n    padding: 10px;\n  }\n}\n\n@media only screen and (max-width: 750px) {\n  .social-card-container {\n    margin-bottom: 0px;\n\n  }\n  .social-card {\n    margin-top: 15px;\n  }\n  \n  .social-card-content {\n    padding: 5px;\n    border-radius: 0px;\n    font-size: 12px;\n    letter-spacing: 0.4ch;\n    padding: 3px;\n    margin-bottom: 0px;\n  }\n  \n  .social-card-content img {\n    width: calc(1em + 20px);\n    height: calc(1em + 20px);\n    margin-bottom: 10px;\n    padding: 10px;\n  }\n  \n  .social-card-name {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
